import './object';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { initialState } from '../store/lang/lang.reducer';
import { ERROR } from './const';

export function withLang(context, name) {
    //use for class components
    Object.assign(context.prototype, {
        get(key) {
            return _Text.bind(this)(name, key);
        },
        getErrorMsg(error, defaultErrMsg = '') {
            let errorMsg = defaultErrMsg;
            if (error.response.data && error.response.data.message) {
                switch (error.response.data.message) {
                    case ERROR.CASE_CANCELLED:
                        errorMsg = this.get('@PatientInfo.msg.caseCancelledMessage');
                        break;
                    case ERROR.DUPLICATE_CASE_SUBMISSION:
                        errorMsg = this.get('@PatientInfo.msg.duplicateCaseSubmissionMessage');
                        break;
                    default:
                        errorMsg = error.response.data.message;
                        break;
                }
            }

            return errorMsg;
        },
    });
    return context;
}

export function useLang(name) {
    // use for functional components
    const lang = useSelector((store) => store.lang);
    const getLang = useCallback(
        (key) => {
            if (key.startsWith(':')) {
                return (
                    getFromObj(lang.dict.global, key.slice(1)) ||
                    getFromObj(initialState.dict.global, key.slice(1)) ||
                    'N/A'
                );
            }
            if (key.startsWith('$')) {
                //Courier in zh-cn lang only
                return lang.dict[key.slice(1)];
            }
            if (key.startsWith('@')) {
                //fully namespace ex get('@global.const.xxx')
                if (getFromObj(lang.dict, key.slice(1)) === null) {
                    return getFromObj(initialState.dict, key.slice(1));
                }
                return getFromObj(lang.dict, key.slice(1)) || 'N/A';
            }
            return getFromObj(lang.dict[name], key) || getFromObj(initialState.dict[name], key) || 'N/A';
        },
        [lang]
    );
    return getLang;
}

function _Text(name, key) {
    if (this.props && this.props.lang && this.props.lang.dict) {
        if (key.startsWith(':')) {
            return (
                getFromObj(this.props.lang.dict.global, key.slice(1)) ||
                getFromObj(initialState.dict.global, key.slice(1)) ||
                'N/A'
            );
        }
        if (key.startsWith('@')) {
            if (getFromObj(this.props.lang.dict, key.slice(1)) === null) {
                return getFromObj(initialState.dict, key.slice(1));
            }

            return (
                getFromObj(this.props.lang.dict, key.slice(1)) || getFromObj(initialState.dict, key.slice(1)) || 'N/A'
            );
        }
        return getFromObj(this.props.lang.dict[name], key) || getFromObj(initialState.dict[name], key) || 'N/A';
    }
    return 'N/A';
}

export function getFromObj(obj, key) {
    return Object.getFromObj(obj, key);
}

export function objToDict(obj) {
    return Object.objToDict(obj);
}
